'use strict';

module.exports = function(source) {
    return JSON.parse(JSON.stringify(source));
};


//////////////////
// WEBPACK FOOTER
// ./~/virtual-scroll/src/clone.js
// module id = 239
// module chunks = 0